import React, { useEffect, useRef } from "react";

type MediaType = "Author" | "Quoted" | "Data Featured" | "Interview" | "Tweet";

interface MediaItem {
  type: MediaType;
  title: string;
  publication: string;
  href: string;
  date?: string;
}

const mediaItems: MediaItem[] = [
  {
    type: "Author",
    title:
      "Memo to Mamdani: Data Shows Massive Jump in Ridership on Bedford Avenue's Embattled Bike Lane",
    publication: "Streetsblog NYC",
    href: "https://nyc.streetsblog.org/2026/01/15/memo-to-mamdani-data-shows-massive-jump-in-ridership-on-bedford-avenues-embattled-bike-lane",
    date: "2026",
  },

  {
    type: "Author",
    title: "Nowhere to park? There’s always the bus stop.",
    publication: "Substack",
    href: "https://patrickcleary1.substack.com/p/nowhere-to-park-theres-always-the",
    date: "2026",
  },
  {
    type: "Author",
    title: "Did the G Train Shutdown Create Permanent Changes?",
    publication: "Substack",
    href: "https://patrickcleary1.substack.com/p/did-the-g-train-shutdown-create-permanent",
    date: "2025",
  },
  {
    type: "Data Featured",
    title: "NYC's Confusing Parking Rules, Finally Mapped",
    publication: "Untapped Cities",
    href: "https://www.untappedcities.com/parking-rules-map-nyc/",
    date: "2024",
  },
  {
    type: "Data Featured",
    title: "Disabled Trains and a Switch Issue Plague Red Line",
    publication: "Boston Globe",
    href: "https://www.bostonglobe.com/2023/08/17/metro/disabled-trains-and-a-switch-issue-plague-red-line/",
    date: "2023",
  },
  {
    type: "Data Featured",
    title: "Red Line: The MBTA Is the Worst",
    publication: "Boston Globe",
    href: "https://www.bostonglobe.com/2023/08/23/metro/red-line-mbta-is-the-worst/",
    date: "2023",
  },
  {
    type: "Tweet",
    title: "Citi Bike Trips – Williamsburg Bridge",
    publication: "Twitter / X",
    href: "https://x.com/PatrickDCleary/status/2014464811321483708",
  },
  {
    type: "Tweet",
    title: "Longest Citi Bike Trips 2025",
    publication: "Twitter / X",
    href: "https://x.com/PatrickDCleary/status/2027118024331829271",
  },
];

const TYPE_LABELS: Record<MediaType, string> = {
  Author: "Author",
  Quoted: "Quoted",
  "Data Featured": "Data Featured",
  Interview: "Interview",
  Tweet: "Tweet",
};

const ArrowIcon = () => (
  <svg fill="none" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M7 17L17 7M7 7h10v10" />
  </svg>
);

export const Media = () => {
  const headerRef = useRef<HTMLDivElement>(null);
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) =>
          e.target.classList.toggle("visible", e.isIntersecting)
        ),
      { threshold: 0.1 }
    );
    if (headerRef.current) observer.observe(headerRef.current);
    itemRefs.current.forEach((r) => r && observer.observe(r));
    return () => observer.disconnect();
  }, []);

  if (mediaItems.length === 0) return null;

  return (
    <section id="media" className="media-section">
      <div className="media-header reveal" ref={headerRef}>
        <h2>Media</h2>
        <span className="media-count">0{mediaItems.length} items</span>
      </div>

      <div className="media-list">
        {mediaItems.map((item, i) => (
          <div
            key={i}
            className="media-item reveal"
            ref={(el) => {
              itemRefs.current[i] = el;
            }}
            style={{ transitionDelay: `${i * 0.05}s` }}
          >
            <a
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className="media-item-inner media-item-link"
            >
              <span
                className={`media-type-badge media-type-${item.type
                  .toLowerCase()
                  .replace(" ", "-")}`}
              >
                {TYPE_LABELS[item.type]}
              </span>
              <div className="media-item-body">
                <span className="media-item-title">{item.title}</span>
                <span className="media-item-publication">
                  {item.publication}
                </span>
              </div>
              <div className="media-item-right">
                {item.date && <span className="media-date">{item.date}</span>}
                <div className="media-link-icon">
                  <ArrowIcon />
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};
